/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gyms_Chips_HintInputs */

const en_us2_gyms_chips_hint = /** @type {(inputs: Gyms_Chips_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The swaps and the next plan use this gym's equipment.`)
};

const pt_br2_gyms_chips_hint = /** @type {(inputs: Gyms_Chips_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As trocas e o próximo plano usam os equipamentos desta academia.`)
};

const es_419_gyms_chips_hint = /** @type {(inputs: Gyms_Chips_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los cambios de ejercicio y el próximo plan usan el equipo de este gimnasio.`)
};

const pt_pt2_gyms_chips_hint = /** @type {(inputs: Gyms_Chips_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As trocas e o próximo plano usam o equipamento deste ginásio.`)
};

const fr_fr2_gyms_chips_hint = /** @type {(inputs: Gyms_Chips_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les remplacements et le prochain programme utilisent l'équipement de cette salle.`)
};

const de_de2_gyms_chips_hint = /** @type {(inputs: Gyms_Chips_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Übungswechsel und der nächste Plan nutzen die Ausstattung dieses Studios.`)
};

const it_it2_gyms_chips_hint = /** @type {(inputs: Gyms_Chips_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le sostituzioni e la prossima scheda usano l'attrezzatura di questa palestra.`)
};

/**
* | output |
* | --- |
* | "The swaps and the next plan use this gym's equipment." |
*
* @param {Gyms_Chips_HintInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const gyms_chips_hint = /** @type {((inputs?: Gyms_Chips_HintInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gyms_Chips_HintInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_gyms_chips_hint(inputs)
	if (locale === "es-419") return es_419_gyms_chips_hint(inputs)
	if (locale === "pt-PT") return pt_pt2_gyms_chips_hint(inputs)
	if (locale === "fr-FR") return fr_fr2_gyms_chips_hint(inputs)
	if (locale === "de-DE") return de_de2_gyms_chips_hint(inputs)
	if (locale === "it-IT") return it_it2_gyms_chips_hint(inputs)
	return en_us2_gyms_chips_hint(inputs)
});
export { gyms_chips_hint as "gyms.chips_hint" }